import styled from "styled-components";
import PieChart from "../../components/charts/PieChart";
import Users from "../users/Users";
import DemoData from "../../data/DemoData";
import StudentTicketItem from "./StudentTicketItem";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import GetStatistics from "../../actions/statistics/GetStatistics";

import AdminDeleteTickets from "../../actions/student/AdminDeleteTickets";
import AdminUpdateDoubtRequest from "../../actions/support/AdminUpdateDoubtRequest";
import PlacementSupportTicketItem from "./PlacementSupportTicketItem";
import { useActionsContext } from "../../context/ActionsContext";
import Localbase from "localbase";
import DetectDevice from "../../context/DetectDevice";
import { Avatar } from "@mui/material";
import { useDispatch } from "react-redux";
function StudentsPlacementSupport({ options }) {
  const dispatch = useDispatch();
const { user } = useContext(AuthContext);
const { permission } = useActionsContext();
const { rowsPerPage, setRowsPerPage } = useActionsContext(); // Already moved earlier
const userdata = user;
const params = useParams();
const [status, setstatus] = useState("all");
const [query, setquery] = useState(null);
const db = new Localbase("db");
const [resolutions, setresolutions] = useState(null);
const [doubts, setdoubts] = useState(null); // Renamed to placementRequests for clarity, but kept as is for now
const [response, setResponse] = useState(null);
const [searchTerm, setSearchTerm] = useState("");
const { searchquery } = useActionsContext();

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

useEffect(() => {
  getPlacementRequests(); // Renamed function call for clarity
}, [status, rowsPerPage]);

const getPlacementRequests = async () => { // Renamed for clarity (was getdoubts)
  dispatch({ type: 'LOADING' });

  const data = new FormData();
  data.append("session", user.SessionId);
  data.append('limit', rowsPerPage); // Explicitly set limit to rowsPerPage
  if (query) {
    data.append("query", query);
  }
  if (status && status !== "all") { // Added check for "all"
    data.append("status", status);
  }
  if (permission?.course_tickets_view) {
    data.append('course_tickets_view', permission.course_tickets_view);
  }

  try {
    const res = await axios.post(
      ENDPOINT + "admin-get-placement-requests.php",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );

    if (res && res.data) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        const placementData = res.data.data || [];
        const resolutionsData = res.data.resolutions || {
          unresolved: 0,
          resolved: 0,
          rejected: 0,
          total: 0,
        };
        setdoubts(placementData); // Assuming setdoubts is used for placement requests
        setResponse(placementData);
        setresolutions(resolutionsData);
        await db.collection("paths").doc("placement_requests").set({ // Use .set() for doc updates
          data: placementData,
          resolutions: resolutionsData
        });
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to fetch placement requests' 
        });
      }
    } else {
      dispatch({ type: 'ERROR', payload: 'No response from server' });
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching placement requests' 
    });
    console.error("Error fetching placement requests:", error);
  }
};

const device = DetectDevice();
const [toast, settoast] = useState(false);
const [toasttitle, settoasttitle] = useState(null);
const [info, setinfo] = useState(null);
const [toastmessage, settoastmessage] = useState(null);

const GetStats = async () => {
  dispatch({ type: 'LOADING' });

  try {
    const res = await GetStatistics({ 
      payload: { SessionId: user.SessionId } 
    });

    if (res && res.status === "success") {
      dispatch({ type: 'DONE_LOADING' });
      setinfo(res.data || null);
      await db.collection("paths").doc("info").set({ info: res.data || null }); // Save to Localbase
    } else {
      dispatch({ 
        type: 'ERROR', 
        payload: res.message || res.data?.message || 'Failed to fetch statistics' 
      });
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching statistics' 
    });
    console.error("Error fetching statistics:", error);
  }
};

const [requestDelete, setRequestDelete] = useState("");

useEffect(() => {
  db.collection("paths").doc("placement_requests").get().then(data => {
    if (data && data.data) {
      setdoubts(data.data);
      setResponse(data.data);
      setresolutions(data.resolutions || {
        unresolved: 0,
        resolved: 0,
        rejected: 0,
        total: 0,
      });
    }
  });
  GetStats();
}, []);

useEffect(() => {
  handleSearch({ term: searchquery });
}, [searchquery]);

const handleSearch = ({ term }) => {
  if (!term && doubts) {
    setResponse(doubts);
    setSearchTerm("");
    return;
  }

  if (term && doubts) {
    const filteredData = doubts.filter((item) => {
      return (
        (item.email && item.email.toLowerCase().includes(term.toLowerCase())) ||
        (item.phone_number && item.phone_number.includes(term)) ||
        (item.first_name && item.first_name.toLowerCase().includes(term.toLowerCase())) ||
        (item.last_name && item.last_name.toLowerCase().includes(term.toLowerCase())) ||
        (item.create_datetime && item.create_datetime.includes(term)) ||
        (item.status && item.status.toLowerCase().includes(term.toLowerCase()))
      );
    });
    setResponse(filteredData);
    setSearchTerm(term);
  }
};

const Reload = () => {
  getPlacementRequests(); // Renamed call
};

const [statistics, setstatistics] = useState(null);

const Statistics = async () => {
  dispatch({ type: 'LOADING' });

  const data = new FormData();
  data.append("session", user.SessionId);

  try {
    const res = await axios.post(
      ENDPOINT + "placement-request-statistics.php",
      data,
      SecurityHeaders
    );

    if (res && res.data && res.data.status === "success") {
      dispatch({ type: 'DONE_LOADING' });
      setstatistics(res.data.data || null);
      await db.collection("paths").doc("statistics").set({ statistics: res.data.data || null }); // Save to Localbase
    } else {
      dispatch({ 
        type: 'ERROR', 
        payload: res.data?.message || 'Failed to fetch statistics' 
      });
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching statistics' 
    });
    console.error("Error fetching statistics:", error);
  }
};

useEffect(() => {
  Statistics();
}, []);

  return (
    <>



      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="h-100">
              {

                options?.search === false ? <></> :
                  <>
                    {parseInt(permission.placement_support_statistics) ? (
                      <>
                        {statistics ? (
                          <>
                            {/*end row*/}
                            <div className="row">
                              <div className="col-lg-3 col-md-3 col-6">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center">
                                      <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                          <i className="ri-arrow-down-circle-fill align-middle" />
                                        </span>
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                          Initiated{" "}
                                        </p>
                                        <h4 className=" mb-0">
                                          <span
                                            className="counter-value"
                                            data-target="14799.44"
                                          >
                                            {statistics.total_initiated}
                                          </span>
                                        </h4>
                                      </div>
                                      <div className="flex-shrink-0 align-self-end d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                        <span className="badge bg-danger-subtle text-danger">
                                          <i className="ri-arrow-down-s-fill align-middle me-1" />
                                          {Math.round(
                                            statistics.percentage_initiated
                                          )}{" "}
                                          %<span> </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* end card body */}
                                </div>
                                {/* end card */}
                              </div>
                              {/* end col */}

                              {/* end col */}
                              <div className="col-lg-3 col-md-3 col-6">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center">
                                      <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                          <i className="ri-arrow-down-circle-fill align-middle" />
                                        </span>
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                          Closed{" "}
                                        </p>
                                        <h4 className=" mb-0">
                                          <span
                                            className="counter-value"
                                            data-target="14799.44"
                                          >
                                            {Math.round(statistics.total_closed)}
                                          </span>
                                        </h4>
                                      </div>
                                      <div className="flex-shrink-0 align-self-end d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                        <span className="badge bg-danger-subtle text-danger">
                                          <i className="ri-arrow-down-s-fill align-middle me-1" />
                                          {statistics.percentage_closed} %
                                          <span> </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* end card body */}
                                </div>
                                {/* end card */}
                              </div>
                              {/* end col */}

                              {/* end col */}
                              <div className="col-lg-3 col-md-3 col-6">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center">
                                      <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                          <i className="ri-arrow-down-circle-fill align-middle" />
                                        </span>
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                          Total{" "}
                                        </p>
                                        <h4 className=" mb-0">
                                          <span
                                            className="counter-value"
                                            data-target="14799.44"
                                          >
                                            {statistics.total_supports}
                                          </span>
                                        </h4>
                                      </div>
                                      <div className="flex-shrink-0 align-self-end d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                        <span className="badge bg-danger-subtle text-danger">
                                          <i className="ri-arrow-down-s-fill align-middle me-1" />
                                          <span> </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* end card body */}
                                </div>
                                {/* end card */}
                              </div>
                              {/* end col */}

                              {/* end col */}
                              <div className="col-lg-3 col-md-3 col-6">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center">
                                      <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                          <i className="ri-arrow-down-circle-fill align-middle" />
                                        </span>
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                          Avg Resolution Time{" "}
                                        </p>
                                        <h4 className=" mb-0">
                                          <span
                                            className="counter-value"
                                            data-target="14799.44"
                                          >
                                            {parseInt(
                                              statistics.average_closed_time_minutes
                                            ) > 60
                                              ? parseInt(
                                                statistics.average_closed_time_minutes
                                              ) /
                                              60 +
                                              " hrs"
                                              : statistics.average_closed_time_minutes +
                                              " mins"}
                                          </span>
                                        </h4>
                                      </div>
                                      <div className="flex-shrink-0 align-self-end d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                        <span className="badge bg-danger-subtle text-danger">
                                          <i className="ri-arrow-down-s-fill align-middle me-1" />
                                          %<span> </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {/* end card body */}
                                </div>
                                {/* end card */}
                              </div>
                              {/* end col */}
                            </div>{" "}
                            {/* end row*/}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}</>
              }

              <div className="row">
                {/* end col sliding section*/}
                <div className="col-12 order-xxl-0 order-first">
                  <div className="col-12 ">
                    <div className="card ">
                    {/* Previous Search Filters */}
                      {/* {options&&
                        (options.search === false) ? <></> :

                          <>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                              <form className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                <div className="row g-3">
                                  <div className="col-xxl-3 col-sm-4">
                                    <div className="search-box">
                                      <input
                                          onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                                        type="text"
                                        className="form-control search"
                                        placeholder="Search for order ID, customer, order status or something..."
                                      />
                                      <i className="ri-search-line search-icon" />
                                    </div>
                                  </div>
                                  <div className="col-xxl-2 col-sm-6">
                                    <div>
                                      <input
                                        type="date"
                                         onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                                        className="form-control"
                                        data-provider="flatpickr"
                                        data-date-format="d M, Y"
                                        data-range-date="true"
                                        id="demo-datepicker"
                                        placeholder="Select date"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-xxl-2 col-sm-4">
                                    <div>
                                      <select
                                        className="form-control"
                                         onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                                        data-choices=""
                                        data-choices-search-false=""
                                        name="choices-single-default"
                                        id="idStatus"
                                      >
                                        <option value="">Status</option>
                                        <option value="unresolved">Unresolved</option>
                                        <option value="initiated">Initiated</option>
                                        <option value="rejected">Rejected</option>
                                        <option value="resolved">Resolved</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-xxl-2 col-sm-4">
                                    <div>
                                      <select
                                        className="form-control"
                                        data-choices=""
                                        data-choices-search-false=""
                                        name="choices-single-default"
                                        id="idPayment"
                                      >
                                        <option value="">Select Payment</option>
                                        <option value="all" selected="">
                                          All
                                        </option>
                                        <option value="Mastercard">Mastercard</option>
                                        <option value="Paypal">Paypal</option>
                                        <option value="Visa">Visa</option>
                                        <option value="COD">COD</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-xxl-3 col-sm-4">
                                    <div className="d-flex">
                                      <button
                                        type="button"
                                        className="btn me-2 btn-primary "
                                        onclick="SearchData();"
                                      >
                                        {" "}
                                        <i className="ri-equalizer-fill me-1 align-bottom" />
                                        Filters
                                      </button>

                                      <button className="btn btn-danger w-fit h-fit">
                                        Add new Task
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div></>
                      } */}

                      {device==="mobile"?<>
             {response?response.map((item)=>(
              <>
              {console.log(item)}
                <div className="col-12 m-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                    <Avatar src={item.profile_pic}/>
                    <div className="ms-2">
                      <h5 className="mb-1">{item.first_name+" "+item.last_name}</h5>
                      <p>{item.course_url}</p>
                    </div>
                    </div>
                    <div className="me-3 d-flex flex-column align-items-end">
                    <span className={`badge ${item.status==='unresolved'?'bg-danger-subtle text-danger':item.status==='initiated'? 'bg-warning-subtle text-warning' :'bg-success-subtle text-success'}`}>
                {item.status}
              </span>
              <Link to={"/students-support/"+item.id} className="btn btn-outline-primary mt-2">View</Link>  
                    </div>
                  </div>
                </div>
              </>
             )):<></>}
    </>
      :
      <>

<div className="card-body">
                        <div className="table-responsive table-card">
                          <table className="table table-borderless table-centered align-middle mb-0">
                            <thead className="text-muted table-light">
                              <tr>
                                <th scope="cqol">User</th>
                                {options?.course === false ? <></> :
                                  <th scope="cqol">course</th>
                                }
                                <th scope="col">Status</th>
                                <th scope="col">Actions</th>

                                <th scope="col">View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {response ? (
                                <>
                                  {response.map((item) => (
                                    <>
                                      <PlacementSupportTicketItem
                                        Reload={Reload}
                                        item={item}
                                        options={options}
                                      />
                                    </>
                                  ))}
                                </>
                              ) : (
                                <></>
                              )}
                            </tbody>
                            {/* end tbody */}
                          </table>
                          {/* end table */}
                        </div>
                      </div>

      </>}

                     
                    </div>{" "}
                  </div>

                  <div className="d-flex mt-4">
                    {/*Graphical data */}

                    <div className="col-lg-5 ps-3">
                      <div className="card"></div>
                    </div>

                    <div className="col-lg-5 ps-2"></div>
                  </div>
                </div>
                {/* end col */}
              </div>

              <div className="row">
                <div className="col-xl-8">{/* end card */}</div>
                {/* end col */}
                <div className="col-xl-4">
                  {/* card */}
                  <div className="card card-height-100">
                    {/* end card body */}
                  </div>
                  {/* end card */}
                </div>
                {/* end col */}
              </div>
            </div>{" "}
            {/* end .h-100*/}
          </div>{" "}
          {/* end col */}
          {/* end col */}
        </div>
      </div>
    </>
  );
}

export default StudentsPlacementSupport;

const StyledSuperAdminDashboard = styled.div`
  h1 {
    color: red;
  }
`;
